<template>
  <div
    v-if="active"
    v-scroll-lock="active"
    class="modal active"
  >
    <div class="modal-overlay"></div>

    <section class="modal-container modal-form modal-form--md">
      <header class="modal-header modal-form__header">
        <a
          class="btn btn-clear float-right modal-form__close"
          aria-label="close"
          @click="close()"
        >
        </a>

        <h1 class="modal-form__title">
          Bloqueio de agenda
        </h1>
      </header>

      <article class="modal-body modal-form__body">
        <div class="modal-form__wrapper">
          <p class="modal-form__text modal-form__text--nomargin">
            Escolha abaixo os consultórios em que
            deseja bloquear sua agenda:
          </p>

          <div class="modal-form__item modal-form__item--mt" style="margin-bottom: 0.5rem">
            <div class="modal-form__col">
              <dr-office-picker v-model="form.chosenOffices" />
            </div>
          </div>

          <div class="
            modal-form__item modal-form__item--40 modal-form__item--mt
            mobile:!justify-start !flex-wrap mobile:!flex-none
          ">
            <p class="modal-form__text modal-form__text--nomargin w-full">
              Início
            </p>
            <div class="modal-form__item modal-form__item--20 modal-form__item--mt mobile:mr-2">
              <div class="modal-form__col has-value">
                <div  class="z-10">
                  <dr-datepicker
                    v-model="form.startDate"
                    id="startDate"
                  />
                </div>
              </div>
            </div>

            <div class="modal-form__item modal-form__item--20 modal-form__item--mt">
              <div class="modal-form__col has-value">
                <p class="modal-form__text" style="margin-left: 0.2rem">
                  às
                </p>

                <div class="appointment-simple__field relative">
                  <!-- Appointment End Hours -->
                  <div
                    v-click-outside="() => ui.showStartHour = false"
                    @click.prevent="ui.showStartHour = !ui.showStartHour"
                  >
                    <span :class="ui.showStartHour && 'appointment-simple__field--nobg'">
                      {{ String(form.startHour).padStart(2, '0') }}
                    </span>

                    <dr-appointment-time-picker
                      v-if="ui.showStartHour"
                      ref="agendaBlockStartHour"
                      :from.sync="startingHour"
                      :selected="form.startHour"
                      :fn="(v) => form.startHour = v"
                      type="hour"
                    />
                  </div>

                  <span style="display: block; margin: 0 0.25rem;">h</span>

                  <!-- Appointment End Minutes -->
                  <div
                    v-click-outside="() => ui.showStartMin = false"
                    @click.prevent="ui.showStartMin = !ui.showStartMin"
                  >
                    <span :class="ui.showStartMin && 'appointment-simple__field--nobg'">
                      {{ String(form.startMin).padStart(2, '0') }}
                    </span>

                    <dr-appointment-time-picker
                      v-if="ui.showStartMin"
                      ref="agendaBlockStartMin"
                      :selected="form.startMin"
                      :fn="(v) => form.startMin = v"
                      type="minute"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-form__item modal-form__item--40 modal-form__item--mt
                      !flex-wrap mobile:!justify-start mobile:py-4 mobile:!flex-none">
            <p class="modal-form__text modal-form__text--nomargin w-full">
              Fim
            </p>

            <div class="modal-form__item modal-form__item--20 modal-form__item--mt mobile:mr-2">
              <div class="modal-form__col has-value">
                <div class="z-8">
                  <dr-datepicker
                    v-model="form.endDate"
                  />
                </div>
              </div>
            </div>
            <div class="modal-form__item modal-form__item--20 modal-form__item--mt">
              <div class="modal-form__col has-value">
                <p class="modal-form__text" style="margin-left: 0.2rem;">
                  às
                </p>

                <div class="appointment-simple__field relative">
                  <!-- Appointment End Hours -->
                  <div
                    v-click-outside="() => ui.showEndHour = false"
                    @click.prevent="ui.showEndHour = !ui.showEndHour"
                  >
                    <span :class="ui.showEndHour && 'appointment-simple__field--nobg'">
                      {{ String(form.endHour).padStart(2, '0') }}
                    </span>

                    <dr-appointment-time-picker
                      v-if="ui.showEndHour"
                      ref="agendaBlockEndHour"
                      :from="1"
                      :selected="form.endHour"
                      :fn="(v) => form.endHour = v"
                      type="hour"
                    />
                  </div>

                  <span style="display: block; margin: 0 0.25rem;">h</span>

                  <!-- Appointment End Minutes -->
                  <div
                    v-click-outside="() => ui.showEndMin = false"
                    @click.prevent="ui.showEndMin = !ui.showEndMin"
                  >
                    <span :class="ui.showEndMin && 'appointment-simple__field--nobg'">
                      {{ String(form.endMin).padStart(2, '0') }}
                    </span>

                    <dr-appointment-time-picker
                      v-if="ui.showEndMin"
                      ref="agendaBlockEndMin"
                      :selected="form.endMin"
                      :fn="(v) => form.endMin = v"
                      type="minute"
                    />
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="modal-form__item modal-form__item--20 modal-form__item--mt !flex-wrap mobile:w-full mobile:!flex-none">
            <p class="modal-form__text modal-form__text--nomargin w-full">
              Motivo
            </p>
            <div class="modal-form__item modal-form__item--100 modal-form__item--mt">
              <div class="modal-form__col">
                <div class="modal-form__field has-value">
                  <div class="modal-form__select has-value">
                    <div>
                      <select
                        v-model="form.reason"
                        id="agendaBlockReason"
                        class="form-select"
                        style="margin-top: 0.3rem"
                      >
                        <option value="" disabled hidden>
                          Escolha
                        </option>

                        <option
                          v-for="(reason, index) in reasons"
                          :key="`reason_${index}`"
                          :value="reason"
                          :selected="form.reason && form.reason === reason"
                        >
                          {{ reason }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </article>

      <footer class="modal-form__footer">
        <dr-submit
          :loading="ui.loading"
          class="appointment-simple__submit"
          text="Bloquear agenda"
          @click="blockAgenda()"
        />
      </footer>
    </section>
  </div>
</template>

<script>
import DrAppointmentTimePicker from '@/components/modals/agenda/appointmentTimePicker'
import DrOfficePicker from '@/components/form/doctorOfficePicker'
import DrDatepicker from '@/components/form/datepicker'
import DrSubmit from '@/components/form/submit'
import { DrCalendar } from 'cm2tech-vue-calendar'
import { mapGetters } from 'vuex'

export default {
  name: 'DrAgendaBlock',

  props: {
    active: {
      type: Boolean,
      required: true
    }
  },

  components: {
    DrAppointmentTimePicker,
    DrOfficePicker,
    DrDatepicker,
    DrSubmit
  },

  data () {
    return {
      reasons: ['Férias', 'Doença', 'Obras', 'Outros'],
      form: {
        chosenOffices: [],
        startDate: null,
        startHour: null,
        startMin: null,
        endDate: null,
        endHour: null,
        endMin: null,
        reason: ''
      },
      ui: {
        showOfficesList: false,
        showStartHour: false,
        showStartMin: false,
        showEndHour: false,
        showEndMin: false,
        loading: false
      }
    }
  },

  computed: {
    ...mapGetters({
      doctorOffices: 'getOffices'
    }),

    prefix () {
      return this.fn_IS_DOCTOR()
        ? '/doctor'
        : `/secretary/doctor/${this.$route.params.doctorId}`
    },

    startingHour () {
      const startingDate = this.$moment(this.form.startDate)

      if (this.$moment().isSame(startingDate, 'day')) {
        return parseInt(this.$moment().format('HH'))
      }

      return 0
    },

    startingMinute () {
      const startingDate = this.$moment(this.form.startDate)

      if (this.$moment().isSame(startingDate, 'day')) {
        return parseInt(this.$moment().add(10, 'minutes').format('mm'))
      }

      return 0
    }
  },

  watch: {
    active: {
      deep: false,
      immediate: false,
      handler (v) {
        if (v) {
          this.createFormData()
        }
      }
    },

    'form.startDate': {
      deep: true,
      immediate: false,
      handler (v) {
        const date = this.$moment(v)

        if (this.$moment().isAfter(date, 'day')) {
          this.form.startDate = this.$moment().toISOString()
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'A data inicial não pode ser menor que hoje.',
            size: 'md',
            active: true
          })

          return
        }

        if (date.isAfter(this.$moment(this.form.endDate), 'day')) {
          this.form.endDate = date.add(1, 'day').toISOString()
        }
      }
    },

    'form.endDate': {
      deep: true,
      immediate: false,
      handler (v) {
        const date = this.$moment(v)

        if (this.$moment(this.form.startDate).isAfter(date, 'day')) {
          this.form.endDate = this.$moment().toISOString()
          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: 'A data final não pode ser menor que a data final.',
            size: 'md',
            active: true
          })
        }
      }
    }
  },

  created () {
    this.createFormData()
  },

  destroyed () {
    this.destroyFormData()
  },

  methods: {
    close () {
      this.destroyFormData()
      this.$emit('cancel')
    },

    createFormData () {
      this.form.startHour = parseInt(this.$moment().add(1, 'hour').format('HH'))
      this.form.startMin = 0

      this.form.endHour = 23
      this.form.endMin = 55

      this.form.startDate = this.$moment().add(1, 'day').toISOString()
      this.form.endDate = this.$moment().add(2, 'day').toISOString()
    },

    destroyFormData () {
      this.form.chosenOffices = []
      this.form.startDate = null
      this.form.startHour = null
      this.form.startMin = null
      this.form.endDate = null
      this.form.endHour = null
      this.form.endMin = null
      this.form.reason = ''
    },

    blockAgenda () {
      if (this.form.chosenOffices.length === 0) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Por favor, escolha um consultório para bloquear a agenda.',
          size: 'md',
          active: true
        })

        return
      }

      if (this.form.reason === '') {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Por favor, escolha um motivo de bloqueio da agenda.',
          size: 'md',
          active: true
        })

        return
      }

      const initialDate = this.$moment(this.form.startDate)
        .startOf('day')
        .set({
          hour: this.form.startHour,
          minute: this.form.startMin,
          second: 0
        })

      const finalDate = this.$moment(this.form.endDate)
        .startOf('day')
        .set({
          hour: this.form.endHour,
          minute: this.form.endMin,
          second: 0
        })

      if (this.$moment().isAfter(initialDate, 'day')) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Por favor, escolha uma data inicial maior ou igual a hoje.',
          size: 'md',
          active: true
        })

        return
      }

      if (finalDate.isBefore(initialDate, 'minute')) {
        this.$store.dispatch('setModalAlert', {
          title: 'Erro',
          body: 'Por favor, escolha uma data inicial menor que a data final.',
          size: 'md',
          active: true
        })

        return
      }

      const promises = []
      const data = {
        'doctor_agenda_block': {
          initialDate: initialDate.format('YYYY-MM-DD HH:mm:ss'),
          finalDate: finalDate.format('YYYY-MM-DD HH:mm:ss'),
          reason: this.form.reason
        }
      }

      if (this.form.chosenOffices.length === this.doctorOffices.length) {
        const url = `${this.prefix}/agenda/agenda_block`

        this.ui.loading = true
        this.fn_SHOW_PROGRESS()
        this.$http
          .post(url, data, this.$store.getters.getAuthHeader)
          .then((res) => {
            this.$store.dispatch('setModalAlert', {
              title: 'Sucesso',
              body: 'A agenda foi bloqueada com sucesso',
              size: 'md',
              active: true
            })
          })
          .catch((err) => this.fn_HANDLE_ERROR(err))
          .finally(() => {
            this.ui.loading = false
            this.fn_HIDE_PROGRESS()
            this.close()
            this.$emit('blocked')
          })
      } else {
        const promises = []
        for (let office of this.form.chosenOffices) {
          const url = `${this.prefix}/doctor_office/${office.id}/agenda/agenda_block`

          promises.push(new Promise((resolve, reject) => {
            this.$http
              .post(url, data, this.$store.getters.getAuthHeader)
              .then(() => resolve(office.id))
              .catch((err) => {
                reject(new Error(`id:${office.id}+err:${this.findErrorMessage(err.errors)}`))
              })
          }))
        }

        this.ui.loading = true
        this.fn_SHOW_PROGRESS()

        this.allSettled(promises)
          .then((results) => {
            const msg = []
            results.forEach((promise) => {
              if (promise.status === 'fulfilled') {
                const name = this.doctorOffices.find(i => i.id === promise.value).name

                msg.push(`A agenda de <strong>${name}</strong> foi atualizada com sucesso.`)
              }

              if (promise.status === 'rejected') {
                const attr = promise.reason.message.split('+')
                const id = attr[0].split('id:')[1]
                const err = attr[1].split('err:')[1]
                const name = this.doctorOffices.find(i => i.id === parseInt(id)).name

                msg.push(`A agenda de <strong>${name}</strong> não pode ser atualizada. Motivo: ${err}`)
              }
            })

            this.$store.dispatch('setModalAlert', {
              title: 'Mensagem',
              body: msg.join('<br><br>'),
              size: 'md',
              active: true
            })
          })
          .finally(() => {
            this.ui.loading = false
            this.fn_HIDE_PROGRESS()
            this.close()
            this.$emit('blocked')
          })
      }
    },

    allSettled (promises) {
      const wrappedPromises = promises
        .map(p => Promise.resolve(p).then(
          val => ({ status: 'fulfilled', value: val }),
          err => ({ status: 'rejected', reason: err })
        ))

      return Promise.all(wrappedPromises)
    },

    findErrorMessage (object) {
      let errorMessage = null

      const recursiveSearch = (object) => {
        for (let value in object) {
          if (value === 'errors') {
            errorMessage = object[value]
            break
          } else {
            recursiveSearch(object[value])
          }
        }
      }

      if (Array.isArray(object)) {
        object.forEach((element) => {
          if (typeof element === 'object') {
            recursiveSearch(element)
          } else {
            errorMessage = element
          }
        })
      } else {
        recursiveSearch(object)
      }

      return errorMessage
    }
  }
}
</script>
